/// <reference path="Utilities/_reference.ts" />

module YVR.Parking {
	// Utilities
	import date = YVR.Utilities.Dates;

	// Classes
	const classes = {
		block: 'yvr-parking',
		button: 'yvr-parking__button'
	};


	function main() {
		eventBindings();
	}


	/**
	 * Set the event bindings on the parking elements.
	 */
	function eventBindings() {
		$(`.${classes.block}`).on('click', `.${classes.button}`, e => {
			e.preventDefault();

			const form = $(e.target).parents('form');
			const valid = form.parsley().validate();

			if (valid) {
				submitForm(form);
			}
		});

		$(`input[name="qsloy"]`).on('change', e => {
			const bcaaField = e.target as HTMLInputElement;
			bcaaField.value = bcaaField.value.replace(/ /g, '');
		});
	}


	/**
	 * Submits the form and sends the user to the correct parking service.
	 * @param {obj} form A jQuery object that contains the parking form.
	 */
	function submitForm(form) {
		let serviceURL = form.data('service-url');

		const startDate = form.find('.yvr-form__date--start:visible').val();
		const startTime = form.find('.yvr-form__time--start:visible').val();

		const startDatetime = date.getDatetimeFromStrings(startDate, startTime);

		const endDate = form.find('.yvr-form__date--end:visible').val();
		const endTime = form.find('.yvr-form__time--end:visible').val();

		const endDatetime = date.getDatetimeFromStrings(endDate, endTime);

		var formData = {};

		// Get entry Day
		const ddd = startDatetime.getDate();

		if (ddd > 0 && ddd < 10) {
			formData["start_date"] = `0${ddd}`;
		} else {
			formData["start_date"] = `${ddd}`;
		}

		// Get entry MMYYYY
		const dmonth = startDatetime.getMonth() + 1;
		const dYear = startDatetime.getFullYear();

		// Adding 0 in front of month value if single digit
		if (dmonth > 0 && dmonth < 10) {
			formData["start_date"] += `0${dmonth}${dYear}`;
		} else if (dmonth < 13) {
			formData["start_date"] += `${dmonth}${dYear}`;
		}

		// Get entry hour
		const dHour = startDatetime.getHours();

		if (dHour >= 0 && dHour < 10) {
			formData["start_time"] = `0${(dHour).toString()}`;
		} else {
			formData["start_time"] = `${(dHour).toString()}`;
		}

		// Get entry minute
		const dMin = startDatetime.getMinutes();

		if (dMin >= 0 && dMin < 10) {
			formData["start_time"] += `0${(dMin).toString()}`;
		} else {
			formData["start_time"] += `${(dMin).toString()}`;
		}

		// Get exit date
		const rdd = endDatetime.getDate();

		if (rdd > 0 && rdd < 10) {
			formData["end_date"] = `0${rdd}`;
		} else {
			formData["end_date"] = `${rdd}`;
		}

		// Get exit month
		const rmonth = endDatetime.getMonth() + 1;

		if (rmonth > 0 && rmonth < 10) {
			formData["end_date"] += `0${(rmonth).toString()}${(endDatetime.getFullYear()).toString()}`;
		} else if (rmonth < 13) {
			formData["end_date"] += `${(rmonth).toString()}${(endDatetime.getFullYear()).toString()}`;
		}

		// Get exit hours
		const rHour = endDatetime.getHours();

		if (rHour >= 0 && rHour < 10) {
			formData["end_time"] = `0${(rHour).toString()}`;
		} else {
			formData["end_time"] = `${(rHour).toString()}`;
		}

		// Get exit minutes
		const rMin = endDatetime.getMinutes();

		if (rMin >= 0 && rMin < 10) {
			formData["end_time"] += `0${(rMin).toString()}`;
		} else {
			formData["end_time"] += `${(rMin).toString()}`;
		}

		// Get promo code if any
		const promo = form.find('input[name="qspc"]').val();

		if (promo !== '') {
			formData["promo_code"] = promo;
		}

		// Get bcaa code if any
		const bcaaCard = form.find('input[name="qsloy"]').val();

		if (bcaaCard !== '') {
			formData["membership_number"] = bcaaCard;
			formData["membership_number_enable"] = "true";
		}

		let winName = 'ParkingWindow';

	    let parkingForm = document.createElement("form");
		parkingForm.setAttribute("method", "post");
		parkingForm.setAttribute("action", serviceURL);
		parkingForm.setAttribute("target", winName);
		for (let i in formData) {
			if (formData.hasOwnProperty(i)) {
				let input = document.createElement('input');
				input.type = 'hidden';
				input.name = i;
				input.value = formData[i];
				parkingForm.appendChild(input);
			}
		}

		document.body.appendChild(parkingForm);
		window.open('', winName);
		parkingForm.target = winName;
		parkingForm.submit();
		document.body.removeChild(parkingForm);
	}


	main();
}
